import { formatToUTCISOString, isDateTimeComplete } from '@shared/utils';
import { useEffect, useMemo } from 'react';

type UseDateTimeUpdaterProps = {
  isIssueHappeningNow: string;
  selectedDateTime: Record<string, number | string>;
  currentDateTime: string;
  updateDateTime: (path: 'dateTime', value: string) => void;
};

export const useDateTimeUpdater = ({
  isIssueHappeningNow,
  selectedDateTime,
  currentDateTime,
  updateDateTime,
}: UseDateTimeUpdaterProps) => {
  // Memoize the computed dateTime to avoid unnecessary re-renders
  const computedDateTime = useMemo(() => {
    const dateTimeCompleteBool = isDateTimeComplete(selectedDateTime);

    if (isIssueHappeningNow.toLowerCase() === 'no' && dateTimeCompleteBool) {
      return formatToUTCISOString(
        selectedDateTime.selectedYear as number,
        selectedDateTime.selectedMonth as number,
        selectedDateTime.selectedDay as number,
        selectedDateTime.selectedHour as number,
        selectedDateTime.selectedMinute as number,
      );
    }

    return new Date().toISOString();
  }, [isIssueHappeningNow, selectedDateTime]);

  useEffect(() => {
    if (
      (isIssueHappeningNow.toLowerCase() === 'yes' ||
        isDateTimeComplete(selectedDateTime)) &&
      computedDateTime !== currentDateTime &&
      computedDateTime !== ''
    ) {
      updateDateTime('dateTime', computedDateTime);
    }
  }, [
    isIssueHappeningNow,
    selectedDateTime,
    currentDateTime,
    updateDateTime,
    computedDateTime,
  ]);
};
